module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABJklEQVQ4T+WUv0rEQBDGv8lEFGsrBTtb+80WNnYWgs1hI1jZ29hYqC9wiBZXCT7AcWJhKWmSPIAvIIh/QFCsTiXZT/ZYJIfEIlfeVLvsN78ZvhlWjDHHInIAYBbtYgjgUJIk8Ye5dozfrGcP4oQQn/4+RaAnERmQ7ABYCN71wzA2wv0BwBWA7Zpm3COSW0VRDIwxeyLSA3CX5/kqAO/lPYBlEdnMsuy6pvlrNsmec+5IVU8BdEh+qOqac24ewK3vjOR5HMcnVVWdeU3ocpqm1nbJRx59A5hpSwh5rx50AWB3EpCIdMUDrLWLqjr2jZRluQLgBoCGIl8isq6qj/WiURQN0zR9GYGawlp7SXLHv5PsFkWx36T9F2SMWYqiqE/yM2z9WxPoB+XUe1KMrjxEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/message.png
// module id = WfKa
// module chunks = 1